import { render, staticRenderFns } from "./Tabgroup.vue?vue&type=template&id=101469f6&"
import script from "./Tabgroup.vue?vue&type=script&lang=js&"
export * from "./Tabgroup.vue?vue&type=script&lang=js&"
import style0 from "./Tabgroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports